<template>
    <section class="main-image-banner">
        <v-container>
            <v-card flat :img="item.image" class="py-30 px-20 border-radius-16 bg-right">
                <v-row align="center" class="row--xxl">
                    <v-col cols="12" lg="auto">
                        <v-img max-width="388" src="/images/main/image-banner/banner-text.svg" alt="">
                            <span class="d-sr-only">
                                {{ item.texts }}
                            </span>
                        </v-img>
                    </v-col>
                    <v-col cols="auto">
                        <v-img src="/images/main/image-banner/banner-text-2.svg" />
                    </v-col>
                    <v-col cols="auto">
                        <v-btn to="/campaign/campaign/infant" large rounded="pill" color="primary" class="mt-24">
                            <span class="page-text page-text--lg white--text">더 알아보기</span>
                            <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </section>
</template>

<script>
export default {
    data() {
        return {
            item: {
                image: "/images/main/image-banner/image-banner.jpg",
                route: "http://localhost:8080/campaign/campaign/infant",
                texts: "혼자가 된 아이들 따뜻한 품으로 안아주세요.",
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.main-image-banner {
    padding-bottom: 60px;
}
.bg-right {
    background-position-x: right;
}
@media (min-width: 1024px) {
    .main-image-banner {
        padding-bottom: 120px;
    }
}
</style>